import * as actions from "./actionTypes";

export const chargerSelected = (chargerId) => {
  if (chargerId == null) return null;

  return {
    type: actions.CHARGER_SELECTED,
    payload: chargerId,
  };
};

// export const updateChargerData = (chargerData) => {
//   //   if (chargerData?.length > 0) return null;
//   console.log("Charger Data action: ", chargerData);

//   return {
//     type: actions.UPDATE_CHARGER_DATA,
//     payload: chargerData,
//   };
// };

export const addChargerIds = (chargerId) => {
  return { type: actions.ADD_CHARGER_IDS, payload: chargerId };
};

export const resetChargerData = () => {
  return {
    type: actions.RESET_CHARGER,
  };
};

export const updateChargerFilter = (filter) => {
  return {
    type: actions.UPDATE_CHARGER_FILTER,
    payload: filter,
  };
};

export const updateStatusFilter = (filter) => {
  return {
    type: actions.UPDATE_FILTER_STATUS,
    payload: filter,
  };
};

export const updateParamFilter = (filter) => {
  return {
    type: actions.UPDATE_FILTER_PARAM,
    payload: filter,
  };
};

export const resetChargerFilter = () => {
  return {
    type: actions.RESET_CHARGER_FILTER,
  };
};
